import styled from 'styled-components';

const HeadingTitle = styled.h4.attrs({className: 'font-semibold mb-2'})`
`;

export default HeadingTitle;